'use client';

import React, { useState, useEffect } from 'react';
import { useLogging } from 'src/context/logging';
import { faLineChart, faHashtag } from '@fortawesome/pro-solid-svg-icons';
import { useEnabledSearchIds } from 'src/modules/Territory/context/enabledSearchIds';
import { useTerritoryContext } from 'src/modules/Territory/context/TerritoryContext';
import { PulseButton } from 'src/components';
import { IconButton } from 'src/components/PulseUI/IconButton';

interface GridTrendingButtonProps {
  table?: string;
}

const GridTrendingButton = ({ table = '' }: GridTrendingButtonProps) => {
  const log = useLogging();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 1023px)');
    setIsMobile(mediaQuery.matches);

    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, []);
  // TODO: add showicon

  const [enabledSearchIds] = useEnabledSearchIds();
  const { volumeToggle, setVolumeToggle } = useTerritoryContext();
  return (
    <>
      {isMobile ? (
        <IconButton
          id={`${table}-trending-button`}
          variant="soft"
          color="neutral"
          icon={volumeToggle ? faHashtag : faLineChart}
          onClick={() => {
            log.event(`Toggle Volume Cell`, {
              type: volumeToggle ? 'Total' : 'Trend',
            });
            setVolumeToggle(!volumeToggle);
          }}
          className="font-black"
          aria-label="Toggle Volume Cell"
        />
      ) : (
        <div className="flex items-center w-full justify-end gap-2 flex-nowrap py-2">
          <PulseButton
            aria-label="Toggle Volume Cell"
            variant="soft"
            color="neutral"
            className="rounded-full text-neutral-800"
            disabled={enabledSearchIds.length === 0}
            startDecorator={volumeToggle ? faHashtag : faLineChart}
            onClick={() => {
              log.event(`Toggle Volume Cell`, {
                type: volumeToggle ? 'Total' : 'Trend',
              });
              setVolumeToggle(!volumeToggle);
            }}
          >
            {volumeToggle ? 'Total' : 'Trend'}
          </PulseButton>
        </div>
      )}
    </>
  );
};

export default GridTrendingButton;
